import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  id: string
  email: string
  name: string
  role: string
  timezone: string
  avatar_url?: string
  org_id: string
  org_slug?: string
  standup_time?: string
  eod_time?: string
  shift_days?: string
  shift_schedule?: Record<string, { enabled: boolean; start: string; end: string }> | null
}

interface AuthState {
  user: User | null
  token: string | null
  org_slug: string | null
  isAuthenticated: boolean
  setAuth: (user: User, token: string, orgSlug?: string) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      org_slug: null,
      isAuthenticated: false,
      setAuth: (user, token, orgSlug) =>
        set({
          user,
          token,
          org_slug: orgSlug || user.org_slug || null,
          isAuthenticated: true,
        }),
      logout: () =>
        set({
          user: null,
          token: null,
          org_slug: null,
          isAuthenticated: false,
        }),
    }),
    {
      name: 'auth-storage',
    }
  )
)
